<template>
    <div class="freetargetImage-box">
        <div class="marqueeWrapper">
            <div class="raceGame-noteStrip">
              Notice : 🎉 Special Event Alert! 🎉 Starts on 20 Oct 2025 — Play More, Earn More! 🎁
            </div>
        </div>
        <img :src='DiwaliWeeklyTarget' alt="" /> 
    </div>    
</template>
<script>
// This page owns the .marqueeWrapper / .raceGame-noteStrip markup above, so it
// imports their styles itself. It used to get them only because
// RewardBlastRule.vue happened to import the same file and is statically
// bundled — that page no longer uses them.
import './TargetRules.css'
import DiwaliWeeklyTarget from '../../assets/images/diwaliWeeklyTarget.webp'
export default {
    name: 'WeeklyTargetRule',
    data() {
        return {
            DiwaliWeeklyTarget: DiwaliWeeklyTarget,
        }
    },
}
</script>
